import { FieldRow as e } from "./FieldRow.es.js";
import { jsx as t } from "react/jsx-runtime";
// lib/TVListing/components/EndTime.tsx
var n = ({ editor: n, element: r, children: i }) => /* @__PURE__ */ t(e, {
	editor: n,
	element: r,
	label: "Sluttid",
	children: i
});
export { n as EndTime };
